import { BillingMode } from '../../../../services/exports/Constants';

export default {
  billing_modes: {
    [BillingMode.Stripe]: 'Maksutapa',
    [BillingMode.InternalInvoicing]: 'Tilitykset',
  },
};
